<div class="header" [class.is-mobile]="mobileQuery.matches">
  <div class="logo">
    <a routerLink="home" aria-label="Ir para Minha Conta">
      <div class="logo-img-wrapper" aria-hidden="true">
        <img class="logo-img" src="assets/Hubmedical-Logo-2026-Fundo-Escuro.svg" alt="Hub Medical Logo" />
        <span class="logo-shimmer" aria-hidden="true"></span>
      </div>
    </a>

    @if(!mobileQuery.matches){
    <span class="text-header">Conexões Entre os Serviços de Saúde</span>
    }
  </div>

  @if(!isAuthenticated()){
  <div class="menu">
    <button mat-flat-button (click)="login()" aria-label="Fazer Login">Login</button>
  </div>
  } @else {
  <div class="menu" role="navigation" aria-label="Menu principal">
    <!-- Notificações -->
    <button mat-icon-button matTooltip="Notificações" (click)="toggleSideBarNotification()"
      [matBadge]="notificationCount" [matBadgeHidden]="notificationCount < 1" aria-label="Notificações">
      <img src="assets/icons/icon_header_notif.svg" alt="Ícone de notificações" />
    </button>

    <!-- Menu Dashboard -->
    @if(!isLoadingProfiles && (profileProviderPF?.id || (profileProviderPJ && profileProviderPJ.length > 0))) {
    <button mat-icon-button [matMenuTriggerFor]="menu2" matTooltip="Meus Perfis: Acesso Rápido"
      aria-label="Meus Perfis: Acesso Rápido">
      <img src="assets/icons/icon_header_dashboard.svg" alt="Ícone de dashboard" />
    </button>

    <mat-menu #menu2="matMenu">
      @if(profileProviderPF?.id){
      <button mat-menu-item [routerLink]="['/providerPF', profileProviderPF?.id]">
        Prestador PF - {{ profileProviderPF?.name }}
      </button>
      }

      @if(profileProviderPJ && profileProviderPJ.length > 0) {
        @for (profilePJ of profileProviderPJ; track profilePJ.id) {
        <button mat-menu-item [routerLink]="['/providerPJ', profilePJ.id]">
          Prestador PJ - {{ profilePJ.companyName }}
        </button>
        }
      }

      @if (hasAdminPermission()) {
      <button mat-menu-item [routerLink]="['/admin']">
        Administrador
      </button>
      }
    </mat-menu>
    }

    <!-- Menu Usuário -->
    @if(userEmail){
    <button mat-icon-button [matMenuTriggerFor]="menu" [matTooltip]="userEmail"
      [attr.aria-label]="'Menu do usuário ' + userEmail">
      <img src="assets/icons/icon_header_user.svg" alt="Ícone de usuário" />
    </button>
    }

    <mat-menu #menu="matMenu">

      <button mat-menu-item routerLink="my-account/user" class="menu-item-with-icon">
        <img src="assets/icons/icon_cadastro.svg" alt="Ícone de Cadastro" width="24px" height="24px" />
        <span>Meu Cadastro</span>
      </button>

      <button mat-menu-item routerLink="my-account/profiles" class="menu-item-with-icon">
        <img src="assets/icons/icon_perfil.svg" alt="Ícone de Perfil" width="24px" height="24px" />
        <span>Meus Perfis</span>
      </button>

      <button mat-menu-item routerLink="my-account/notification" class="menu-item-with-icon">
        <img src="assets/icons/icon_notif.svg" alt="Ícone de Notificações" width="24px" height="24px" />
        <span>Minhas Notificações</span>
      </button>

      <button mat-menu-item routerLink="my-account/my-plans" class="menu-item-with-icon">
        <img src="assets/icons/icon_meusplanos.svg" alt="Ícone de Meus Planos" width="24px" height="24px" />
        <span>Meus Planos</span>
      </button>

      <button mat-menu-item routerLink="my-account/my-payments" class="menu-item-with-icon">
        <img src="assets/icons/icon_pgtos.svg" alt="Ícone de Meus Pagamentos" width="24px" height="24px" />
        <span>Meus Pagamentos</span>
      </button>


      <!-- <button mat-menu-item routerLink="/my-account" aria-label="Acessar minha conta">Conta</button> -->
      <!-- <button mat-menu-item (click)="setScreenMode()">
          {{ theme === "dark" ? "Modo claro" : "Modo escuro" }}
        </button> -->

      <button mat-menu-item (click)="logout()" class="menu-item-with-icon" aria-label="Encerrar sessão">
        <img src="assets/icons/icon_power_DUO.svg" alt="Ícone de Meus Pagamentos" width="24px" height="24px" />
        <span>Sair</span>

      </button>
    </mat-menu>

    <!-- Botão Menu Mobile -->
    @if(mobileQuery.matches || !sidebarOpened){
    <div>
      <button mat-icon-button (click)="toggleSideBar()" aria-label="Abrir menu principal">
        <img src="assets/icons/icon_header_menu.svg" alt="Ícone do menu" />
      </button>
    </div>
    }
  </div>
  }
</div>